export default __webpack_public_path__ + "static/media/DB_6.92b14162.png";